import { useContext } from 'react'
import { NavLink } from "react-router-dom";
import classnames from 'classnames';

import logo from '../images/logo.png';
import facebook from '../images/facebook.svg';
import twitter from '../images/twitter.svg';

import './styles.scss';

import { localize, LanguageContext } from '../Localization'


function share(site, language) {
  const url = encodeURIComponent(document.location)
  const description = encodeURIComponent(localize(language, 'header', 'twitter'))
  return () => {
    let link = null
    switch (site) {
      case 'fb':
        // eslint-disable-next-line no-undef
        link = `https://www.facebook.com/sharer.php?u=${url}`
        break
      case 'twitter':
        link = `https://twitter.com/intent/tweet?url=${url}&text=${description}`
        break
      default:
        link = null
        break
    }
    if (link !== null) {
      window.open(link)
    }
  }
}
export default function Header(props) {
  const { setLanguage } = props
  const languages = [{ label: 'English', key: 'english'}, {label: 'Español', key: 'spanish' }]
  const language = useContext(LanguageContext)
  return (
    <div className='Header'>
      <div className='top'>
        <div className='logo'>
          <img src={logo} alt='' />
        </div>
        <div className='title'>
          <NavLink to='/'>
            <span>
              {localize(language, 'header', 'title')}
            </span>
          </NavLink>
        </div>
        <div className='languages'>
          {languages.map(({label, key}) => (
            <div key={key} onClick={() => setLanguage(key)} className={classnames('language', { selected: language === key })}>
              <span>{label}</span>
            </div>
          ))}
        </div>
        <div className='socials'>
          <div className='social'>
            <img src={facebook} alt='facebook' onClick={share('fb', language)} />
          </div>
          <div className='social'>
            <img src={twitter} alt='twitter' onClick={share('twitter', language)} />
          </div>
        </div>
      </div>
      <div className='bottom'>
        <div className='actions left'>
          <div className='action'>
            <NavLink to='/' activeClassName='active' exact>
              <span>
                {localize(language, 'navigation', 'home')}
              </span>
            </NavLink>
          </div>
          <div className='action'>
            <NavLink
              to='SchoolSiteBudgets'
              activeClassName='active'
            >
              <span>
                {localize(language, 'school site budgets', 'title')}
              </span>
            </NavLink>
          </div>
          <div className='action'>
            <NavLink
              to='CentralSupportsandAdmin'
              activeClassName='active'
            >
              <span>
                {localize(language, 'central supports and admin', 'title')}
              </span>
            </NavLink>
          </div>
        </div>
        <div className='actions right'>
          <div className='action'>
            <a href='https://drive.google.com/drive/folders/1FQGM1HP6XMM2BDFJnvC6OVO8ERVRVqy3?usp=sharing' target='_blank' rel='noopener noreferrer'>
              <span>
                {localize(language, 'navigation', 'download')}
              </span>
            </a>
          </div>
          <div className='action'>
            <NavLink to='/About' activeClassName='active'>
              <span>
                {localize(language, 'navigation', 'about')}
              </span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}
